import { render, staticRenderFns } from "./ServiceNumberBillTotalLineChart.vue?vue&type=template&id=1b897020&scoped=true&"
import script from "./ServiceNumberBillTotalLineChart.vue?vue&type=script&lang=js&"
export * from "./ServiceNumberBillTotalLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b897020",
  null
  
)

export default component.exports